import { CompteurState } from '@/modules/Outils/store';
import { Civilite } from '@/modules/Outils/store/state';
import { CompteurDto } from '@/models/CompteurDto';

export class FormulaireCompteurDto {
    raisonSociale: string;
    nomCommercial: string;
    numeroIdentifiant: string;
    adressePostale: string;
    codePostal: number | undefined;
    ville: string;

    civilite: Civilite;
    nomRepresentant: string;
    prenomRepresentant : string;
    dateNaissanceRepresentant: string;
    emailRepresentant: string;
    adresseRepresentantIdentique: boolean;
    adresseRepresentant: string;
    codePostalRepresentant: number | undefined;
    villeRepresentant: string;

    compteurs: CompteurDto[] | undefined = [];

    constructor(compteur: CompteurState){
        this.raisonSociale = compteur.raisonSociale;
        this.nomCommercial = compteur.nomCommercial;
        this.numeroIdentifiant = compteur.numeroIdentifiant;
        this.adressePostale = compteur.adressePostale;
        this.codePostal = compteur.codePostal;
        this.ville = compteur.ville;
        this.civilite = compteur.civilite;
        this.nomRepresentant = compteur.nomRepresentant;
        this.prenomRepresentant = compteur.prenomRepresentant;
        this.dateNaissanceRepresentant = compteur.dateNaissanceRepresentant;
        this.emailRepresentant = compteur.emailRepresentant;
        this.adresseRepresentantIdentique = compteur.adresseRepresentantIdentique;
        this.adresseRepresentant = compteur.adresseRepresentant;
        this.villeRepresentant = compteur.villeRepresentant;
        this.codePostalRepresentant = compteur.codePostalRepresentant;
        compteur.compteurs?.forEach(compteur => {
           this.compteurs?.push(new CompteurDto(compteur.numeroCompteur, compteur.facture !== undefined ? compteur.facture.name : ''));
        });
    }
}
